import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/business/leads/new")({
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/sales/leads/new", search, replace: true });
    },
});
